// src/data/mockVideos.js
// Real YouTube videos aligned with CareLink's mission (NYC aid, housing, food, benefits)
// Shape matches YouTube Search API results used in Community.jsx

const MOCK_VIDEOS = [
  {
    id: { videoId: "w8iG4Sg0194" },
    snippet: {
      title: "How To Apply For Food Stamps (SNAP) in New York",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/w8iG4Sg0194/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "Ky5ims7ZA-Y" },
    snippet: {
      title: "How to Apply for SNAP Benefits in NYC (Step-by-Step)",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/Ky5ims7ZA-Y/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "DECVwR7006k" },
    snippet: {
      title: "Using the ACCESS HRA App for NYC Benefits",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/DECVwR7006k/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "wBpCe48zr6w" },
    snippet: {
      title: "Upload Documents with ACCESS HRA (NYC)",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/wBpCe48zr6w/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "eFRPf7Bto5k" },
    snippet: {
      title: "ACCESS HRA Website & Mobile App Overview",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/eFRPf7Bto5k/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "xT8oszsPHME" },
    snippet: {
      title: "How to Apply for Fair Fares NYC Online",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/xT8oszsPHME/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "F0Dht0LhP7c" },
    snippet: {
      title: "NYC Affordable Housing Lottery Explained",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/F0Dht0LhP7c/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "Ih1BJcsHfY4" },
    snippet: {
      title: "Housing Connect NYC – Full Application Walkthrough",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/Ih1BJcsHfY4/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "51YlXIPQ5lQ" },
    snippet: {
      title: "How to Apply on Housing Connect 2.0 (NYC)",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/51YlXIPQ5lQ/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "aLSy1guS9Po" },
    snippet: {
      title: "How to Win the NYC Housing Lottery",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/aLSy1guS9Po/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "-sXQ3FJeU7Q" },
    snippet: {
      title: "How I Got a NYC Apartment Through the Housing Lottery",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/-sXQ3FJeU7Q/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "LD-3VJWgL2w" },
    snippet: {
      title: "Housing Connect Approval Tips (NYC)",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/LD-3VJWgL2w/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "0cIErRLoBeM" },
    snippet: {
      title: "Food Bank for NYC: Fighting Hunger Citywide",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/0cIErRLoBeM/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "oM9zkT3z6gU" },
    snippet: {
      title: "How Food Banks Support NYC Families",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/oM9zkT3z6gU/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "6pRwGfYXKCg" },
    snippet: {
      title: "East Harlem Food Pantry Helping Local Residents",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/6pRwGfYXKCg/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "XXAyhvSY4KI" },
    snippet: {
      title: "How to Help Food Bank for New York City",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/XXAyhvSY4KI/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "ql4B3CkIVoc" },
    snippet: {
      title: "Food Bank for NYC on Giving Tuesday",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/ql4B3CkIVoc/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "xW9odhYqoZs" },
    snippet: {
      title: "NYC Food Insecurity: How Communities Are Responding",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/xW9odhYqoZs/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "Rzyu886fGv0" },
    snippet: {
      title: "Housing Connect 2.0 Explained for NYC Residents",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/Rzyu886fGv0/mqdefault.jpg" }
      }
    }
  },
  {
    id: { videoId: "jz5K3qXGzW0" },
    snippet: {
      title: "Mental Health Resources & Free Clinics in NYC",
      thumbnails: {
        medium: { url: "https://i.ytimg.com/vi/jz5K3qXGzW0/mqdefault.jpg" }
      }
    }
  }
];

export default MOCK_VIDEOS;
